import React from 'react';
import { Tooltip } from '@mui/material';
import { LockOutlined as LockOutlinedIcon } from '@mui/icons-material';

export default function AdminBadge({ userProfile }) {
  const role = userProfile?.role;
  if (role !== 'admin' && role !== 'developer') return null;
  return (
    <Tooltip title="Solo administradores" placement="top" arrow>
      <LockOutlinedIcon
        sx={{ fontSize: 14, color: 'text.disabled', ml: 0.5, verticalAlign: 'middle', flexShrink: 0 }}
      />
    </Tooltip>
  );
}
